export function RoadTripIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M8 32c8-16 24-16 32 0" />
      <circle cx="14" cy="28" r="2" fill="currentColor" />
      <circle cx="24" cy="22" r="2" fill="currentColor" />
      <circle cx="34" cy="28" r="2" fill="currentColor" />
      <path d="M14 28l10-6 10 6" />
      <line x1="20" y1="36" x2="28" y2="36" />
    </svg>
  );
}
